import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';

import CustomBreadcrumb from 'app/components/Navbar/CustomBreadcrumb';

import { layoutStyles } from '@aslanpay/portal-common-lib';

import NavbarActions from './NavbarActions';

function Navbar() {
  const isMobileOrTablet = useBreakpointValue({ base: true, sm: true, lg: false }) ?? true;

  return (
    <Flex
      bg="brand.white"
      borderBottom="1px solid"
      borderColor="brand.lightGray1"
      h={layoutStyles.navbar.height.base}
      p={{ base: '0px 30px 0px 20px', sm: '0px 56px 0px 46px', lg: '0px 40px 0px 30px' }}
    >
      <Flex justify="space-between" align="center" width="full">
        {/* Left side - Breadcrumb */}
        <Box flex={1}>
          <CustomBreadcrumb />
        </Box>

        {/* Right side - Contact Aslan and User Profile */}
        {!isMobileOrTablet && <NavbarActions />}
      </Flex>
    </Flex>
  );
}

export default Navbar;
